module.exports = __webpack_public_path__ + "static/media/TUNE_4374.b30b5109.jpg";